import { types, applySnapshot } from "mobx-state-tree";
import { Framework } from "@flint/framework";

const EPubSyncAllModel = types
  .model("EPubSyncAllModel", {
    res: types.string,
  })
  .actions((self) => ({
    fetch() {
      Framework.sendEvent("SYNC_ALL_EPUB_DATA");
    },
    set(response) {
      let res = response.data.response;
      let successISBN = [];
      let failedISBN = [];
      for (let isbn in res) {
        if (res[isbn] === "SUCCESS") successISBN.push(isbn);
        else if (res[isbn] === "FAILED") failedISBN.push(isbn);
      }
      let resString="";
      let successString=`Cloud Sync for the book(s) with ISBN ${successISBN.join(", ")} is successful.`
      let failedString=`Cloud Sync for the book(s) with ISBN ${successISBN.join(", ")} failed.`
      if(failedISBN.length===0){
        resString=successString;
      }
      else if(successISBN.length===0){
        resString=failedString;
      }
      else{
        resString=`${successString}\n\n${failedString}`;
      }
      applySnapshot(self, {
        res: resString,
      });
    },
    reset() {
      applySnapshot(self, {
        res: "Oops...Something went wrong. Please try again.",
      });
    },
  }));

export default EPubSyncAllModel;
